// <auto-generated>
// Code generated by EDHC (R) Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is
// regenerated.
// Hash: 1537155558
// </auto-generated>
import {
  StringLength,
  RegularExpression,
  Required,
  EmailAddress,
  MinValue,
} from 'carehub-shared/validators';

export class DocumentType {
  @Required()
  documentTypeId: number;
  @StringLength(256)
  description: string;
  @Required()
  isGenerated: boolean;
  @Required()
  isCommentAllowed: boolean;
  inactiveDate: Date | string;
  createdUserId: string;
  updatedUserId: string;
  createdDate: Date | string;
  updatedDate: Date | string;
}

export function initializeNewDocumentType(): DocumentType {
  const instance = new DocumentType();
  instance.documentTypeId = null;
  instance.description = '';
  instance.isGenerated = false;
  instance.isCommentAllowed = false;
  instance.inactiveDate = null;
  instance.createdUserId = '00000000-0000-0000-0000-000000000000';
  instance.updatedUserId = '00000000-0000-0000-0000-000000000000';
  instance.createdDate = null;
  instance.updatedDate = null;
  return instance;
}
